import cn from "classnames";
import React, { ReactNode } from "react";
import { Col, Row } from "reactstrap";
import { SocialProvider } from "../../../../cores/socialPost/interfaces/socialProvider";
import { LoadingSpinnerWembii } from "../../LoadingSpinnerWembii";
import { PanelWembii } from "../../PanelWembii";

interface Props {
  social: SocialProvider;
  children?: ReactNode;
  bindLoading?: boolean;
  removeShadow?: boolean;
  getLoading?: boolean;
  isSync: boolean;
  /** When set, uses an expanded layout with title + description (user settings integrations). */
  description?: ReactNode;
}

export default function SocialRow({
  social,
  children,
  bindLoading,
  removeShadow,
  getLoading,
  isSync,
  description,
}: Props) {
  const { id, name, email, icon, avatar, displayName, url } = social;

  const accountBlock = (
    <>
      <LoadingSpinnerWembii active={getLoading}>
        {avatar && (
          <img className="socialCard-avatar" src={avatar} alt="avatar" />
        )}
      </LoadingSpinnerWembii>
      <div className="ml-2">
        {displayName && <div className="truncate">{displayName}</div>}
        {url && (
          <div className="small truncate mb-2">
            <a href={url} target="_black">
              {url}
            </a>
          </div>
        )}
        {email && <div className="small truncate mb-2">{email}</div>}
      </div>
    </>
  );

  if (description) {
    return (
      <PanelWembii
        key={id}
        shadow={!removeShadow}
        className={cn(
          "integration-bind-row border-0 text-left my-2",
          { "integration-bind-row--connected": isSync }
        )}
      >
        <div className="integration-bind-row__inner">
          <div className="integration-bind-row__header">
            <div className="integration-bind-row__icon-wrap">{icon}</div>
            <div className="integration-bind-row__body">
              <div className="integration-bind-row__title">{name}</div>
              <div className="small text-muted integration-bind-row__desc">
                {description}
              </div>
              {isSync && (
                <div className="integration-bind-row__account d-flex align-items-center">
                  {accountBlock}
                </div>
              )}
            </div>
          </div>
          <div className="integration-bind-row__actions">
            <LoadingSpinnerWembii active={bindLoading}>
              {children}
            </LoadingSpinnerWembii>
          </div>
        </div>
      </PanelWembii>
    );
  }

  return (
    <PanelWembii
      key={id}
      shadow={!removeShadow}
      className="align-content-center border-0 justify-content-center px-3 py-2 text-center my-2"
    >
      <Row>
        <Col xs="12" lg="2">
          <div className="d-flex align-items-center h-100">{icon}</div>
        </Col>
        <Col xs="12" lg="5">
          <div className="d-flex align-items-center h-100">
            {!isSync ? (
              <span className="font-weight-bold">{name}</span>
            ) : (
              accountBlock
            )}
          </div>
        </Col>
        <Col xs="12" lg="5">
          <div className="d-flex align-items-center h-100">
            <LoadingSpinnerWembii active={bindLoading}>
              {children}
            </LoadingSpinnerWembii>
          </div>
        </Col>
      </Row>
    </PanelWembii>
  );
}
